import React from 'react'

import PropTypes from 'prop-types'

import './hero3.css'

const Hero3 = (props) => {
  return (
    <div className="hero3-header9">
      <img
        alt={props.image1Alt}
        src={props.image1Src}
        className="thq-img-ratio-16-9"
      />
    </div>
  )
}

Hero3.defaultProps = {
  image1Src: '/screenshot%202024-08-06%20at%2012.22.21-1500w.png',
  image1Alt: 'Diverse group of people working together on computers',
}

Hero3.propTypes = {
  image1Src: PropTypes.string,
  image1Alt: PropTypes.string,
}

export default Hero3
